import { render } from "./DashboardView.vue?vue&type=template&id=25cdd2ec"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"
script.render = render

export default script